export default __webpack_public_path__ + "5ab54bce9efb6fa2f977dee7c65a484b.png";